import { SectionTabs } from '../val';
import Collapse from '../../../base/collapse'; 
import Locale from '../../../../mixins/locale'
import Load from '../../../base/page/'

export default {
    inject: ['root'],
    mixins: [Locale],
    props: {
        tab: String
    },
    components: {
        Collapse,
        Load
    },
    data() {
        return {
            list: [],
            SectionTabs,
            page: 1,
            size: 5,
            hasMore: true,
            loading: false
        }
    },
    methods: {
        handleChecked(checked, data) {
            if(checked && 1 + this.root.selectedCount > this.root.limit && this.root.limit != 1) {
                Message.warning(t('selectMember.maximum'))
                return false
            }
            data.checked = checked
            this.root.handleSelected(data)
            return true
        },
        resetSearch() {
            this.page = 1;
            this.list = [];
        }
    }
}